import cn from 'classnames';
import React, { SelectHTMLAttributes, ReactNode, forwardRef } from 'react';
import styles from './index.module.scss';

export type SelectProps = {
  className?: string;
  children?: ReactNode;
  placeholder?: string;
  isRequired?: boolean;
  bgColor?: string;
} & SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<any, SelectProps>(
  (
    {
      children,
      className,
      placeholder,
      isRequired,
      onFocus,
      bgColor,
      ...rest
    }: SelectProps,
    ref,
  ) => {
    const classes = cn(styles.wrap, className);
    const bgColorClass = {
      [styles[`select--${bgColor}`]]: bgColor,
    };

    return (
      <div className={classes}>
        <select
          onFocus={onFocus}
          ref={ref}
          className={cn(styles.select, bgColorClass)}
          required={isRequired}
          {...rest}
        >
          {placeholder && (
            <option className={styles.placeholder} value="">
              {placeholder}
            </option>
          )}
          {children}
        </select>
      </div>
    );
  },
);

if (process.env.REACT_APP_ENV !== 'production') {
  Select.displayName = 'Select';
}
